import { withStyles } from '@material-ui/core';

import Row from './component';
import styles from './styles';

export default withStyles(styles)(Row);
